import Sidebar from './Sidebar';
import { type UserInToken } from '../../common/types';
import { useState } from 'react';

interface IProps {
  authUser: UserInToken;
  children?: React.ReactNode;
}

const VerticalLayout: React.FC<IProps> = ({ authUser, children }) => {
  const [open, setOpen] = useState(true);

  const sideMenuCollapseHandler = (): void => {
    setOpen(!open);
  };

  return (
    <div className="flex">
      <div className={`${open ? 'w-72' : 'w-20'} p-6 pt-8 duration-300  h-screen bg-sidebarBlack relative`}>
        <Sidebar authUser={authUser} open={open} setOpen={sideMenuCollapseHandler} />
      </div>
      <div className="w-full mx-auto p-6 pt-10 flex-1 h-screen bg-[#E6E9EB]">{children}</div>
    </div>
  );
};

export default VerticalLayout;
